import auth from '@/common/auth/auth';
import BatchRefundJobModel from '@/common/models/jobs/batch-refund-job-model';
import {createDialog, vConfirm} from '@/components/modal/dialogs';

export default {
    label: 'Refund Selected Items...',
    icon: 'batch',
    handler: async (grid, rows) => {
        const ids = rows.map(row => row.fields.id);
        const job = new BatchRefundJobModel({api: grid.$api, ids});

        const confirmDialog = createDialog(vConfirm, grid);
        const dialogParams = {
            title: 'Refund Transactions',
            content: `Are you sure you want to refund ${ids.length} transaction${ids.length === 1 ? '' : 's'}?`,
            confirmLabel: 'Refund',
        };

        if (await confirmDialog(dialogParams)) {
            grid.$store.dispatch('jobs/addJob', {job});
        }
    },
    predicate: auth.transactions.refund.isAllowed,
};
